export default "__VITE_ASSET__BCAo1H4R__"